import request from "@/utils/request";
import qqMapRequest from '@/utils/qqMapRequest.js';

// 获取司机当前位置
export function getDriverPosition(orderId){
  return request({
    // url:"/logistic/app/api/orderselect/appGetPositionInfo/" + orderId,
    url:"/logistic/dispatchapp/api/orderselect/getPositionInfoV2/" + orderId,
    method:"GET"
  })
};

// 获取订单数据
export function getOrderData(orderId){
  return request({
    url:"/logistic/dispatchapp/api/orderselect/dispatch/getdetailsV2/" + orderId,
    method:"GET"
  })
}

export function geocoder(params) { 
  return qqMapRequest({
      url:'/ws/geocoder/v1',
      method:'GET',
      params
  })
}

/* 驾车（driving）路线规划 */
export function directionDriving(params){
  return qqMapRequest({
    url:'/ws/direction/v1/driving',
    method:'GET',
    params
  })
}